var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H21C22.1046 1 23 1.89543 23 3C23 4.10457 22.1046 5 21 5H3C1.89543 5 1 4.10457 1 3Z",
    fill: "#2786BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 10.8954 1.89543 10 3 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H3C1.89543 14 1 13.1046 1 12Z",
    fill: "#2786BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 19.8954 1.89543 19 3 19H21C22.1046 19 23 19.8954 23 21C23 22.1046 22.1046 23 21 23H3C1.89543 23 1 22.1046 1 21Z",
    fill: "#2786BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2ed5616ca0535fbb8f5f2ab4d1058119.svg";
export { ForwardRef as ReactComponent };